<!--<div class="container mt-15">
  <div class="row imgAmbulance mt-4">
      <div class="col-6 mx-auto lh-sm">
        <span class="fs-2 fw-bold ">Tu bienestar,
          <br>
          <span class="fw-light fst-italic">nuestro compromiso</span>
        </span>
    </div>
    <div class="col-6 mx-auto ">
      <img ngSrc="assets/img/movilink/ambulancia.svg" alt="ambulancia" class=" flex-shrink-0" height="600" width="800">
    </div>
    <span class="spanDisclaimer fst-italic">*Cobertura dentro de Guayaquil</span>

  </div>
</div>-->


<div class="container col-xxl-8 px-4 py-5">
  <div class="row flex-lg-row-reverse align-items-center g-5 py-5">
    <div class="col-10 col-sm-8 col-lg-6">
      <img src="assets/img/movilink/ambulancia.svg" class="d-block mx-lg-auto img-fluid" alt="Bootstrap Themes" width="1000" height="700" loading="lazy">
    </div>
    <div class="col-lg-6">
      <p class="fs-2 fw-bold my-0  " style="color: var(--primary-color)">Tu bienestar,</p>
      <p class="fs-2 lh-1" style="color: var(--primary-color)">nuestro compromiso</p>
      <span class="fst-italic fw-bolder" style="color: var(--primary-color)">*Cobertura dentro de Guayaquil</span>
    </div>
  </div>
</div>
